import lodashSortBy from "lodash/sortBy";

export const getSortedTotals = (rowData: any[], asc: boolean, property: (o: any) => any) => {
    const groupedData: any = {};
    rowData?.forEach((element) => {
        const id: string = Object.values(element.compositeKeyFields).join("@");
        if (!groupedData[id]) {
            groupedData[id] = {
                total: {
                    units: element.item?.quantity || 0,
                    wholesale: element.item?.quantity * element.item.price?.amount || 0,
                },
                data: [{ ...element }],
            };
        } else {
            const { units, wholesale } = groupedData[id].total;
            groupedData[id].total = {
                units: units + (element.item?.quantity || 0),
                wholesale: wholesale + element.item?.quantity * (element.item.price?.amount || 0),
            };
            groupedData[id].data.push({ ...element });
        }
    });

    const sortedGroupData = lodashSortBy(groupedData, property);

    if (!asc) {
        sortedGroupData.reverse();
    }

    const totals = [].concat(...sortedGroupData.map(({ data }) => data));
    return totals;
};
